import { useState } from 'react'
import { DialogBody, DialogFooter, DialogHeader, Modal } from '../Modal.js'
import { Button, Field, Textarea } from '../ui.js'

/**
 * A note is written in a window, the same way an email and a text are. It is
 * opened from the card's header; the activity column only reads notes.
 */
export function NoteCompose({
  open,
  onClose,
  isAddingNote,
  onAddNote,
}: {
  open: boolean
  onClose: () => void
  isAddingNote: boolean
  onAddNote: (body: string, done: () => void) => void
}) {
  if (!open) return null
  return (
    <NoteForm isAddingNote={isAddingNote} onAddNote={onAddNote} onClose={onClose} />
  )
}

function NoteForm({
  isAddingNote,
  onAddNote,
  onClose,
}: {
  isAddingNote: boolean
  onAddNote: (body: string, done: () => void) => void
  onClose: () => void
}) {
  const [draft, setDraft] = useState('')

  return (
    <Modal open onClose={onClose} labelledBy="note-compose-title" className="max-w-[480px]">
      <DialogHeader id="note-compose-title" title="New note" onClose={onClose} />
      <DialogBody>
        <Field label="Note" htmlFor="note-compose-body">
          <Textarea
            id="note-compose-body"
            aria-label="New note"
            rows={5}
            value={draft}
            placeholder="Write a note. The technician sees it on the phone."
            onChange={(event) => setDraft(event.target.value)}
          />
        </Field>
      </DialogBody>
      <DialogFooter>
        <Button size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="sm"
          variant="primary"
          loading={isAddingNote}
          disabled={draft.trim().length === 0}
          onClick={() => onAddNote(draft.trim(), () => {
            setDraft('')
            onClose()
          })}
        >
          Add the note
        </Button>
      </DialogFooter>
    </Modal>
  )
}
